// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MapWrapper_wrapper__OB_Wl","mapHeight":"MapWrapper_mapHeight__1nZDq"};